import { render, staticRenderFns } from "./ReturnProductList.vue?vue&type=template&id=e123cbc2&"
import script from "./ReturnProductList.vue?vue&type=script&lang=js&"
export * from "./ReturnProductList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports